window.addEventListener('load', function () {

  const shadow = document.querySelector('#tidio-chat').shadowRoot;
  const style = document.createElement('style');
  style.textContent = `
    @media screen and (max-width: 600px) 
    {
        .mobile #button.chat-closed:not(.sidebar).mobile-size__small {
            transform: scale(1) !important; 
        }

    } 
  `;
  shadow.appendChild(style);

  let lastScrollTop = 0;
  const header = document.querySelector(".stkbl-outer-container");

  window.addEventListener("scroll", function () {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    const windowWidth = window.innerWidth;

    // Check if mobile device (width < 640px)
    if (windowWidth < 640) {
      // Only apply the 400px scroll threshold on mobile
      if (scrollTop > 400) {
        if (scrollTop > lastScrollTop) {
          // Scrolling down, hide the header
          header.style.top = "-40px";
        } else {
          // Scrolling up, show the header
          header.style.top = "0";
        }
      } else {
        // If scroll is less than 400px, keep header visible
        header.style.top = "0";
      }
    } else {
      // On larger screens (width >= 640px), hide/show header on scroll immediately
      if (scrollTop > lastScrollTop) {
        // Scrolling down, hide the header
        header.style.top = "-400px";
      } else {
        // Scrolling up, show the header
        header.style.top = "0";
      }
    }

    lastScrollTop = scrollTop;
  });
});

